module.exports = __webpack_public_path__ + "static/media/logo.ab7100ec.png";